/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BulkActionResultDtoOfString,
  CreateInitialAdminUserDto,
  DatabaseBackupResult,
  DatabaseChangeJobInfoDto,
  EmailSettingsEditDto,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100ForbiddenException,
  ErrorResponseOfPtw100InternalServerException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100UnauthorizedException,
  InstallationConfigDto,
  UpdateConnectionStringsRequestDto,
  UpdateSiteNameRequestDto,
} from '../models/index';
import {
    BulkActionResultDtoOfStringFromJSON,
    BulkActionResultDtoOfStringToJSON,
    CreateInitialAdminUserDtoFromJSON,
    CreateInitialAdminUserDtoToJSON,
    DatabaseBackupResultFromJSON,
    DatabaseBackupResultToJSON,
    DatabaseChangeJobInfoDtoFromJSON,
    DatabaseChangeJobInfoDtoToJSON,
    EmailSettingsEditDtoFromJSON,
    EmailSettingsEditDtoToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100ForbiddenExceptionFromJSON,
    ErrorResponseOfPtw100ForbiddenExceptionToJSON,
    ErrorResponseOfPtw100InternalServerExceptionFromJSON,
    ErrorResponseOfPtw100InternalServerExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    InstallationConfigDtoFromJSON,
    InstallationConfigDtoToJSON,
    UpdateConnectionStringsRequestDtoFromJSON,
    UpdateConnectionStringsRequestDtoToJSON,
    UpdateSiteNameRequestDtoFromJSON,
    UpdateSiteNameRequestDtoToJSON,
} from '../models/index';

export interface CreateAdminUserRequest {
    createInitialAdminUserDto?: CreateInitialAdminUserDto;
}

export interface UpdateConnectionStringsRequest {
    updateConnectionStringsRequestDto?: UpdateConnectionStringsRequestDto;
}

export interface UpdateEmailSettingsRequest {
    emailSettingsEditDto?: EmailSettingsEditDto;
}

export interface UpdateSiteNameRequest {
    updateSiteNameRequestDto?: UpdateSiteNameRequestDto;
}

/**
 * 
 */
export class InstallApi extends runtime.BaseAPI {

    /**
     * Creates the initial admin user during installation.
     */
    async createAdminUserRaw(requestParameters: CreateAdminUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/installation-configuration/admin-user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInitialAdminUserDtoToJSON(requestParameters['createInitialAdminUserDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Creates the initial admin user during installation.
     */
     async createAdminUser(requestParameters: CreateAdminUserRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<InstallApi['createAdminUserRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.createAdminUserRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Creates a backup of the databases.
     */
    async createBackupRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/installation-configuration/database/backups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseBackupResultFromJSON), "DatabaseBackupResult" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseBackupResultFromJSON));
					}
				}
				// -- Responses
    }

    /**
     * Creates a backup of the databases.
     */
     async createBackup(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<InstallApi['createBackupRaw']>>, Array<DatabaseBackupResult>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<DatabaseBackupResult>;

         const response = this.createBackupRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Deletes all existing database backup files.
     */
    async deleteBackupFilesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/installation-configuration/database/backups`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => BulkActionResultDtoOfStringFromJSON(jsonValue), "BulkActionResultDtoOfString" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => BulkActionResultDtoOfStringFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Deletes all existing database backup files.
     */
     async deleteBackupFiles(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<InstallApi['deleteBackupFilesRaw']>>, BulkActionResultDtoOfString>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = BulkActionResultDtoOfString;

         const response = this.deleteBackupFilesRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the names of the existing database backup files.
     */
    async getBackupFilesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/installation-configuration/database/backups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						return new runtime.JSONApiResponse<any>(response);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse<any>(response);
					}
				}
				// -- Responses
    }

    /**
     * Returns the names of the existing database backup files.
     */
     async getBackupFiles(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<InstallApi['getBackupFilesRaw']>>, Array<string>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<string>;

         const response = this.getBackupFilesRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the current installation configuration.
     */
    async getInstallationConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/installation-configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => InstallationConfigDtoFromJSON(jsonValue), "InstallationConfigDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => InstallationConfigDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns the current installation configuration.
     */
     async getInstallationConfig(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<InstallApi['getInstallationConfigRaw']>>, InstallationConfigDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = InstallationConfigDto;

         const response = this.getInstallationConfigRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the state of the running database connection string update.
     */
    async getUpdateConnectionStringsStateAsyncRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/installation-configuration/database/state`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseChangeJobInfoDtoFromJSON(jsonValue), "DatabaseChangeJobInfoDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseChangeJobInfoDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns the state of the running database connection string update.
     */
     async getUpdateConnectionStringsStateAsync(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<InstallApi['getUpdateConnectionStringsStateAsyncRaw']>>, DatabaseChangeJobInfoDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = DatabaseChangeJobInfoDto;

         const response = this.getUpdateConnectionStringsStateAsyncRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Starts updating the database connection strings; the progress is available via the state route.
     */
    async updateConnectionStringsRaw(requestParameters: UpdateConnectionStringsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/installation-configuration/database`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateConnectionStringsRequestDtoToJSON(requestParameters['updateConnectionStringsRequestDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 202: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 500: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100InternalServerExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100InternalServerException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Starts updating the database connection strings; the progress is available via the state route.
     */
     async updateConnectionStrings(requestParameters: UpdateConnectionStringsRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<InstallApi['updateConnectionStringsRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.updateConnectionStringsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Updates the email settings during installation.
     */
    async updateEmailSettingsRaw(requestParameters: UpdateEmailSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/installation-configuration/email-settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmailSettingsEditDtoToJSON(requestParameters['emailSettingsEditDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Updates the email settings during installation.
     */
     async updateEmailSettings(requestParameters: UpdateEmailSettingsRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<InstallApi['updateEmailSettingsRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.updateEmailSettingsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Sets the optional site name provided by the customer.
     */
    async updateSiteNameRaw(requestParameters: UpdateSiteNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/installation-configuration/site-name`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSiteNameRequestDtoToJSON(requestParameters['updateSiteNameRequestDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Sets the optional site name provided by the customer.
     */
     async updateSiteName(requestParameters: UpdateSiteNameRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<InstallApi['updateSiteNameRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.updateSiteNameRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
